<template>
  <span class="error-text">
    {{ message }}
  </span>
</template>

<script>
export default {
  props: ["errors", "field"],
  computed: {
    message() {
      if (this.errors.has(this.field)) {
        return this.errors.get(this.field);
      }
      return "";
    }
  }
};
</script>
